import { ClaimStatuses, ViewClaimFilters } from 'all-in-one-shared-api';
import { Select } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Option {
  label: string;
  value: string;
}

interface ClaimStatusDropdownProps {
  onChange: React.Dispatch<React.SetStateAction<ViewClaimFilters>>;
}

const { Option } = Select;

interface StatusOption {
  label: string;
  value: ClaimStatuses | '';
}

const ClaimStatusDropdown = ({ onChange }: ClaimStatusDropdownProps) => {
  const { t } = useTranslation();
  const [selectedClaimStatus, setSelectedClaimStatus] = useState<ClaimStatuses | ''>();
  const statusOptions: StatusOption[] = [
    {
      label: t('enum.claimStatus.ALL_STATUS'),
      value: '',
    },
    {
      label: t('enum.claimStatus.SUBMITTED'),
      value: 'SUBMITTED',
    },
    {
      label: t('enum.claimStatus.IN_PROGRESS'),
      value: 'IN_PROGRESS',
    },
    {
      label: t('enum.claimStatus.NEED_ACTION'),
      value: 'NEED_ACTION',
    },
    {
      label: t('enum.claimStatus.COMPLETED'),
      value: 'COMPLETED',
    },
    {
      label: t('enum.claimStatus.DECLINED'),
      value: 'DECLINED',
    },
  ];

  function handleStatusChange(value: StatusOption['value']) {
    // if (value) {
    setSelectedClaimStatus(value);
    // }
    onChange((state) => ({
      ...state,
      claimStatuses: value ? [value] : undefined,
    }));
  }

  return (
    <Select
      value={selectedClaimStatus}
      style={{ width: 210 }}
      placeholder={t('enum.claimStatus.ALL_STATUS')}
      onChange={handleStatusChange}
    >
      {statusOptions.map(({ label, value }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  );
};

export default ClaimStatusDropdown;
